export default function initPlanFunctions() {
  const isPresent = document.querySelector(".object-package-select");
  if (!isPresent) {
    return;
  }

  // Select all relevant elements
  const packageButtons = document.querySelectorAll(".object-package-select");
  const planButtons = document.querySelectorAll(".object-plan-select");
  const extraOptions = document.querySelectorAll("[data-extra-option-value]");
  const totalPriceElement = document.querySelector("[data-total-price]");
  const summaryPlan = document.querySelector("[data-summary-plan]");
  const summaryPackage = document.querySelector("[data-summary-package]");
  const summaryExtraOptions = document.querySelector(
    "[data-summary-extra-options]"
  );
  const summaryTotalPrice = document.querySelector(
    "[data-summary-total-price]"
  );
  const summaryTextarea = document.querySelector(
    ".object-form-summary textarea"
  );
  const footerSummaryTotalPrice = document.querySelector(
    "[data-footer-summary-total-price]"
  ); // New element

  let selectedExtras = new Set(); // Store selected extra option values
  let activePackageButton = document.querySelector(
    ".object-package-select.active"
  ); // Track the currently active package button
  let activePlanButton = document.querySelector(".object-plan-select.active"); // Track the currently active plan button

  // Function to update the active package button based on the active plan button
  const updateActivePackage = () => {
    const activePlan = document.querySelector(".object-plan-select.active"); // Get the currently active plan button

    if (!activePlan) return; // If no plan is active, do nothing

    const packageAButton = document.querySelector(
      ".object-package-select[data-package-a]"
    );

    // If active plan is data-plan-b or data-plan-c
    if (!activePlan.hasAttribute("data-plan-a")) {
      // Add "inactive" class to data-package-a button
      if (packageAButton) {
        packageAButton.classList.add("inactive");
        // If data-package-a is currently active, switch to data-package-b
        if (activePackageButton === packageAButton) {
          // Remove active class from packageAButton
          packageAButton.classList.remove("active");
          // Find data-package-b button
          const packageBButton = document.querySelector(
            ".object-package-select[data-package-b]"
          );
          if (packageBButton) {
            packageBButton.classList.add("active");
            activePackageButton = packageBButton;
          }
        }
      }
    } else {
      // Remove "inactive" class from data-package-a button
      if (packageAButton) {
        packageAButton.classList.remove("inactive");
      }
    }

    // Update the total price and summary
    updateTotalPrice();
    updateSummary();
  };

  // Function to calculate and update the total price
  const updateTotalPrice = () => {
    const originalPrice =
      parseInt(
        totalPriceElement.dataset.originalPrice.replace(/\s/g, ""),
        10
      ) || 0; // Get original price
    const addToPrice = activePackageButton
      ? parseInt(
          activePackageButton
            .getAttribute("data-add-to-price")
            .replace(/\s/g, ""),
          10
        ) || 0
      : 0;

    // Sum the values of selected extra options
    const extrasTotal = Array.from(selectedExtras).reduce(
      (sum, value) => sum + value,
      0
    );

    const newTotalPrice = originalPrice + addToPrice + extrasTotal;

    // Format the price with a thousand separator (space)
    const formattedPrice = new Intl.NumberFormat("en-US", {
      useGrouping: true,
      minimumFractionDigits: 0,
    })
      .format(newTotalPrice)
      .replace(/,/g, " ");

    // Update the total price element
    totalPriceElement.textContent = formattedPrice;

    // Update the summary total price
    if (summaryTotalPrice) summaryTotalPrice.textContent = formattedPrice;

    // Update the footer summary total price
    if (footerSummaryTotalPrice)
      footerSummaryTotalPrice.textContent = formattedPrice;
  };

  // Function to update the summary
  const updateSummary = () => {
    // Update plan summary
    const activePlanTitle =
      activePlanButton?.getAttribute("data-plan-title") || "N/A";
    if (summaryPlan) summaryPlan.textContent = activePlanTitle;

    // Update package summary
    const activePackageTitle =
      activePackageButton?.getAttribute("data-package-title") || "N/A";
    if (summaryPackage) summaryPackage.textContent = activePackageTitle;

    // Update extra options summary
    const extraOptionsSummary = Array.from(selectedExtras)
      .map((value) => {
        const option = Array.from(extraOptions).find(
          (el) =>
            parseInt(el.dataset.extraOptionValue.replace(/\s/g, ""), 10) ===
            value
        );
        const title = option?.getAttribute("data-extra-option-title") || "";
        const formattedValue = value.toLocaleString().replace(/,/g, " ");
        return `${title} (${formattedValue} €)`;
      })
      .join(", ");

    if (summaryExtraOptions)
      summaryExtraOptions.textContent = extraOptionsSummary || "Ei ole valitud";

    // Update the summary total price
    const formattedPrice = summaryTotalPrice?.textContent || "0";

    // Create the summary data string
    const summaryData = `Planeering: ${activePlanTitle}
Pakett: ${activePackageTitle}
Lisavalikud: ${extraOptionsSummary || "Ei ole valitud"}
Lõplik hind: ${formattedPrice} €`;

    // Update the textarea in the form
    if (summaryTextarea) {
      summaryTextarea.value = summaryData;
    }
  };

  // Add click event listeners to extra options
  extraOptions.forEach((option) => {
    option.addEventListener("click", () => {
      const optionValue =
        parseInt(option.dataset.extraOptionValue.replace(/\s/g, ""), 10) || 0;

      // Toggle the selected state
      if (selectedExtras.has(optionValue)) {
        selectedExtras.delete(optionValue); // Remove from selected extras
        option.classList.remove("selected"); // Optional: Add a visual cue for deselection
      } else {
        selectedExtras.add(optionValue); // Add to selected extras
        option.classList.add("selected"); // Optional: Add a visual cue for selection
      }

      // Update the total price and summary
      updateTotalPrice();
      updateSummary();
    });
  });

  // Add click event listeners to plan buttons
  planButtons.forEach((planButton) => {
    planButton.addEventListener("click", () => {
      // Remove active class from all plan buttons
      planButtons.forEach((btn) => btn.classList.remove("active"));

      // Add active class to the clicked plan button
      planButton.classList.add("active");

      // Update the active plan button
      activePlanButton = planButton;

      // Update the package selection based on new logic
      updateActivePackage();
    });
  });

  // Add click event listeners to package buttons
  packageButtons.forEach((packageButton) => {
    packageButton.addEventListener("click", (e) => {
      if (e.target.closest("[data-extra-info-tippy]")) return;
      // If the button has class "inactive", do nothing
      // if (packageButton.classList.contains("inactive")) {
      //   return;
      // }

      // Check if user clicked on Package A while Plan B or C is active.
      const isPackageA = packageButton.hasAttribute("data-package-a");
      const activePlanIsNotA =
        activePlanButton && !activePlanButton.hasAttribute("data-plan-a");

      if (isPackageA && activePlanIsNotA) {
        // Switch to Plan A
        const planAButton = document.querySelector(
          ".object-plan-select[data-plan-a]"
        );
        if (planAButton) {
          // Remove active class from all plan buttons
          planButtons.forEach((btn) => btn.classList.remove("active"));
          // Activate plan A
          planAButton.classList.add("active");
          activePlanButton = planAButton;
        }

        // Since plan A is now active, we should remove the inactive class from package A if present
        const packageAButton = document.querySelector(
          ".object-package-select[data-package-a]"
        );
        if (packageAButton) {
          packageAButton.classList.remove("inactive");
        }
      }

      // Remove active class from all package buttons
      packageButtons.forEach((btn) => btn.classList.remove("active"));

      // Add active class to the clicked package button
      packageButton.classList.add("active");

      // Set the new active package button
      activePackageButton = packageButton;

      // Update the total price and summary
      updateTotalPrice();
      updateSummary();
    });
  });

  // Initial setup: Ensure the default state is correct
  updateActivePackage(); // Ensure package logic aligns with the default plan
  updateTotalPrice(); // Calculate the initial total price
  updateSummary(); // Update the initial summary
}
